/* eslint-disable no-restricted-syntax */
export const OCP_APIM_SUBSCRIPTION_KEY_HEADER = 'Ocp-Apim-Subscription-Key';
